import { InboxChatsListItem } from './InboxChatsListItem';

export { InboxChatsListItem };
export default InboxChatsListItem;
